import ApplicationController from '../../application_controller';

export class EmbedV1CarouselController extends ApplicationController {
  static targets = ["container", "leftButton", "rightButton"];

  connect() {
    if (!this.hasContainerTarget) return;

    const container = this.containerTarget;

    // Add js-enabled class to hide scrollbar if JS is enabled
    container.classList.add('js-enabled');

    const hideButtons = container.scrollWidth <= container.clientWidth;
    const buttonDisplay = hideButtons ? "none" : "flex";

    if (this.hasLeftButtonTarget) {
      this.leftButtonTarget.style.display = buttonDisplay;
    }

    if (this.hasRightButtonTarget) {
      this.rightButtonTarget.style.display = buttonDisplay;
    }
  }

  getScrollAmount() {
    const tileWidth = 240; // each tile is 240px wide
    const container = this.containerTarget;
    const containerWidth = container.clientWidth;
    const numberOfTiles = Math.floor(containerWidth / tileWidth);

    return tileWidth * numberOfTiles;
  }

  scrollLeft() {
    if (!this.hasContainerTarget) return;

    const container = this.containerTarget;
    const scrollAmount = this.getScrollAmount();
    const newScroll = Math.max(0, container.scrollLeft - scrollAmount);

    container.scrollTo({ left: newScroll, behavior: "smooth" });
  }

  scrollRight() {
    if (!this.hasContainerTarget) return;

    const container = this.containerTarget;
    const scrollAmount = this.getScrollAmount();
    const maxScroll = container.scrollWidth - container.clientWidth;
    const newScroll = Math.min(maxScroll, container.scrollLeft + scrollAmount);

    container.scrollTo({ left: newScroll, behavior: "smooth" });
  }
}
